import graphql from 'graphql-tag'
import client from '@stores/apollo'

import { IPageInfo, IAssetTag } from '@api'
import { AssetTagFragment, PageInfoFragment } from '@api/fragments'

export default function list({
  after,
  orderBy,
  first,
  queryString,
}: {
  after: string | null
  orderBy: string
  first: number
  queryString?: string
}): Promise<{
  assetTags: IAssetTag[]
  pageInfo: IPageInfo
  counters: { total: number }
}> {
  // ignore snake case
  // eslint-disable-next-line
  let where = queryString ? { name_contains: queryString } : undefined
  return client.gql.query({ query, variables: { after, orderBy, first, where } }).then(
    ({
      data: {
        viewer: {
          company: {
            assetTags: { edges, pageInfo, counters },
          },
        },
      },
    }: {
      data: {
        viewer: {
          company: {
            assetTags: {
              edges: { node: IAssetTag }[]
              pageInfo: IPageInfo
              counters: { total: number }
            }
          }
        }
      }
    }) => ({ assetTags: edges.map(({ node }) => node), edges, pageInfo, counters })
  )
}

export const query = graphql`
  query AssetTagList($after: String, $orderBy: TagOrderByEnum, $first: Int, $where: TagWhereInput) {
    viewer {
      company {
        assetTags(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...AssetTagFragment
            }
          }
        }
      }
    }
  }
  ${AssetTagFragment}
  ${PageInfoFragment}
`
